import { ChangeItem, ChangeType } from '@app/features/scope-overview/change-request/model'
import { ScopeElementsConfig } from '../../models'

export const isChangeItemRemoved = (config: ScopeElementsConfig, changeItem: ChangeItem) =>
  config?.isChangeRequest && (config?.showDiff || config?.showNetDelta) && changeItem?.changeType === ChangeType.REMOVED

export const isChangeItemAdded = (config: ScopeElementsConfig, changeItem: ChangeItem, entity?: any) =>
  !!(
    config?.isChangeRequest &&
    (config?.showDiff || config?.showNetDelta) &&
    (changeItem?.changeType === ChangeType.ADDED ||
      (entity && !entity.changeAuditData?.identity) ||
      (config?.showNetDelta && entity?.isAdded))
  )
